export default __webpack_public_path__ + "static/media/Lato-Regular.755c4a43.woff2";